import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CheckCircle2, XCircle } from "lucide-react";

export type ResponseDto = {
  num_nodes: number;
  num_edges: number;
  is_dag: boolean;
};

export default function ResponseDialog({
  response,
  open,
  setOpen,
}: {
  response: ResponseDto | null;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  if (!response) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            Pipeline Analysis Results
            {response.is_dag ? (
              <CheckCircle2 className="text-green-500" size={20} />
            ) : (
              <XCircle className="text-red-500" size={20} />
            )}
          </DialogTitle>
          <DialogDescription className="space-y-4">
            <div className="mt-4 space-y-2">
              <p>
                <span className="font-semibold">Number of Nodes:</span>{" "}
                {response.num_nodes}
              </p>
              <p>
                <span className="font-semibold">Number of Edges:</span>{" "}
                {response.num_edges}
              </p>
              <p>
                <span className="font-semibold">Pipeline Structure:</span>{" "}
                {response.is_dag
                  ? "Valid - No cycles detected"
                  : "Invalid - Cycles detected in pipeline"}
              </p>
            </div>
            {!response.is_dag && (
              <div className="mt-2 text-red-500">
                Warning: Your pipeline contains cycles. For proper execution,
                ensure that data flows in one direction without loops.
              </div>
            )}
            <div className="mt-4">
              <p className="mb-2 text-sm font-semibold">Raw Response:</p>
              <pre className="p-4 overflow-auto text-sm rounded-md bg-slate-950 text-slate-50">
                {JSON.stringify(response, null, 2)}
              </pre>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
